// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1f5I2","disabled":"FileBtn_disabled__1KVsa","warn":"FileBtn_warn__636ZL","fade":"FileBtn_fade__YR3uA"};